import { Store } from 'containers/my_sessions/types';

export interface User {
    approved?: boolean;
    created?: string;
    creator?: string;
    email?: string;
    firstName?: string;
    id: string;
    lastName?: string;
    phone?: string;
    updated?: string;
    updater?: string;
    userName: string;
    userType: UserType;
    bio?: string;
    gender?: string;
    profileImageUrl?: string;
    level?: {
        title: string;
        value: string;
        imageUrl: string;
    };
    stylistExpertiseId?: [string];
    stylistExpertise?: StylistExpertise[];
    stores: Store[];
    availableForStylingSessions: boolean;
}

export interface StylistExpertise {
    id: string;
    title: string;
    value: string;
}

export enum UserType {
    Admin = 'admin',
    Customer = 'customer',
    Stylist = 'stylist',
    Va = 'va',
}
